export const categories = [
  { slug: 'mingxing', name: '明星爆料', icon: 'ri-star-line' },
  { slug: 'wanghong', name: '网红黑料', icon: 'ri-user-smile-line' },
  { slug: 'bagua', name: '娱乐八卦', icon: 'ri-chat-smile-2-line' },
  { slug: 'zuixin', name: '最新瓜报', icon: 'ri-fire-line' },
  { slug: 'shenba', name: '深度扒皮', icon: 'ri-search-eye-line' },
  { slug: 'rela', name: '热门辣评', icon: 'ri-message-3-line' },
];